
let styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
  },

  table: {
    backgroundColor: '#FFFFFF',
    padding: '1%',
  },

  items: {
    padding: '1%',
    display:'flex',
    flexDirection:'row'
  },
  fixture_list: {
    marginBottom: '1%',
    backgroundColor: '#39435c',
    padding: '1%',
    alignSelf: 'center',
    marginLeft: '58px',
  },

  item_header: {
    fontSize: '100%',
    fontWeight: 600,
    // paddingLeft: '10%',
    width:'51%'
  },

  item_body: {
    padding: '6px ',
    width:'49%'
  },

  main_header: {
    marginBottom: '1%',
    backgroundColor: '#32B6A7',
  },
   bot_header: {
    padding: '1%',
    marginBottom: '1%',
    backgroundColor: '#32B6A7',
  },

  button_submit: {
    justifyContent: 'center',
  },

  input: {
    width: '50%',
  },

  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  }
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/customerDetails/style.js